import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'abrNumber',
  standalone: false,
})
export class AbrNumberPipe implements PipeTransform {
  public transform(value: number, digits = 3): string {
    return abbrNumber(value, digits);
  }
}

export function abbrNumber(value: number, digits: number): string {
  const levels = [
    { metric: '', name: '', from: 0, to: 1000 },
    { metric: 'k', name: 'tusen', from: 1000, to: 1000000 },
    { metric: 'M', name: 'millioner', from: 1000000, to: 1000000000 },
    { metric: 'G', name: 'milliarder', from: 1000000000, to: 1000000000000 },
    { metric: 'T', name: 'trillioner', from: 1000000000000, to: 1000000000000000 },
  ];
  if (value === null) {
    return null;
  }
  if (value === undefined) {
    return undefined;
  }

  if (value || value === 0) {
    for (const level of levels) {
      if (level.from <= Math.abs(value) && Math.abs(value) < level.to) {
        const denominator = level.from === 0 ? 1 : level.from;
        const valueAbr = value / denominator;
        if (digits) {
          value = parseFloat(valueAbr.toFixed(digits));
        }
        return value + ' ' + level.name;
      }
    }
  }
  const lastLevel = levels[levels.length - 1];
  const valueAbr = value / lastLevel.from;
  if (digits) {
    value = parseFloat(valueAbr.toFixed(digits));
  }
  return value + ' ' + lastLevel.name;
}
